import { GET_ROTATE_POSITIONS, GET_ROTATE_POSITIONS_SUCCESS, GET_ROTATE_POSITIONS_ERROR } from './actionTypes';

const initialState = {
  errorGetRotatePositions: '',
  loadingGetRotatePositions: false,
  rotate_positions: null,
  successGetRotatePositions: '',
};

const getRotatePositions = (state = initialState, action) => {
  switch (action.type) {
    case GET_ROTATE_POSITIONS:
      state = {
        ...state,
        loadingGetRotatePositions: true,
      };
      break;
    case GET_ROTATE_POSITIONS_SUCCESS:
      state = {
        ...state,
        loadingGetRotatePositions: false,
        rotate_positions: action.payload.rotate_positions,
        successGetRotatePositions: action.payload.message,
      };
      break;
    case GET_ROTATE_POSITIONS_ERROR:
      state = { ...state, errorGetRotatePositions: action.payload, loadingGetRotatePositions: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getRotatePositions;
